module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-4-photo-5-2739cf09ec5671c0de27a5518aef1394.webp";